import * as z from 'zod';

// Types
import { ArticleZod } from '@/types/Blog/ArticleType';

const CategoryZod = z.object({
  id: z.number(),
  documentId: z.string(),
  slug: z.string(),
  name: z.string(),
  description: z.string().nullish(),
  get articles() {
    return z.array(ArticleZod).nullish();
  },
});

export { CategoryZod };
export type BlogType = z.infer<typeof CategoryZod>;
